/**
 * 弹窗
 */
import { Modal as Dialog } from '@bfe/moly';
import classNames from 'classnames';
import styles from './style.module.scss';
import { ModalProps } from '@bfe/moly/dist/es/components/ui/modal';
import { useFm } from '@web3/base-hooks';
import { useScreenType } from '@/hooks/media';

export type IModalProps = {
  visible: boolean;
  title?: ModalProps['title']; // string | boolean | Element | undefined;
  type?: ModalProps['type']; //'successful' | 'failed' | 'alert' | 'pending' | null;
  className?: string;
  footer?: React.ReactNode;
  okText?: string;
  cancelText?: string | boolean;
  size?: 'small' | 'medium' | 'large';
  confirmBtnDisabled?: boolean;
  loading?: boolean;
  buttonFull?: boolean;
  maxHeight?: number | string;
  onCancel?: () => void;
  onOk?: () => void;
  children?: React.ReactNode;
  buttonVertical?: boolean;
};

export default function Modal(props: IModalProps) {
  const { isMobile } = useScreenType();
  const fm = useFm();
  const {
    title = '',
    visible = false,
    type,
    size = 'medium',
    footer = undefined,
    cancelText = fm('word_close') || false,
    okText = fm('word_confirm'),
    confirmBtnDisabled = false,
    loading = false,
    className = '',
    // buttonFull = true,
    // maxHeight = "600px",
    children,
    onOk,
    onCancel,
    buttonVertical,
  } = props;
  // console.log(height);

  return (
    <Dialog
      title={title}
      open={visible}
      type={type}
      size={size}
      isMobile={isMobile}
      okText={okText}
      cancelText={cancelText}
      onOk={onOk}
      confirmBtnDisabled={confirmBtnDisabled || loading}
      onCancel={onCancel}
      footer={footer}
      direction={isMobile ? 'bottom' : ''}
      className={classNames([
        className,
        // isMobile && '!w-full',
        footer && styles['moly-modal-button-h5-custom'],
      ])}
      buttonVertical={buttonVertical}
    >
      <div
        className={classNames([`px-0 !w-full pr-3 -mr-3  overflow-y-auto`])}
        style={
          {
            // width: '100%',
            // maxHeight: !isMobile ? `${height * 0.8 - 160}px` : 'auto',
          }
        }
      >
        {/* <ScrollArea
          style={{
            width: '100%',
            height: !isMobile ? `${height * 0.8 - 160}px` : 'auto',
          }}
        > */}
        {children}
        {/* </ScrollArea> */}
      </div>
    </Dialog>
  );
}
